
Array.prototype.Exists = function (v) {
    var b = false;
    for (var i = 0; i < this.length; i++) {
        if (this[i] == v) {
            b = true; break;
        }
    }
    return b;
}
import jquery from '@/utils/jquery.min.js'
import { getRcToken,getRcUid } from './auth';
import configStore from '@/store/configStore'

export default {
    time: function (time = +new Date()) {
        var date = new Date(time + 8 * 3600 * 1000); // 增加8小时
        return date.toJSON().substr(0, 19).replace('T', ' ');
    },
    formatDate: function (s) {
        var now=new Date(s);
        var year = now.getFullYear();  //取得4位数的年份
        var month = now.getMonth() + 1;  //取得日期中的月份，其中0表示1月，11表示12月
        var date = now.getDate();      //返回日期月份中的天数（1到31）
        var hour = now.getHours();     //返回日期中的小时数（0到23）
        var minute = now.getMinutes(); //返回日期中的分钟数（0到59）
        var second = now.getSeconds(); //返回日期中的秒数（0到59）
        return year + "-" + month + "-" + date+" "+hour+":"+minute+":"+second;
    },
    date: function(format, timestamp){ 
        var a, jsdate=((timestamp) ? new Date(timestamp*1000) : new Date()); 
        var pad = function(n, c){ 
         if((n = n + "").length < c){ 
          return new Array(++c - n.length).join("0") + n; 
         } else { 
          return n; 
         } 
        }; 
        var txt_weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]; 
        var txt_ordin = {1:"st", 2:"nd", 3:"rd", 21:"st", 22:"nd", 23:"rd", 31:"st"}; 
        var txt_months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]; 
        var f = { 
         // Day 
         d: function(){return pad(f.j(), 2)}, 
         D: function(){return f.l().substr(0,3)}, 
         j: function(){return jsdate.getDate()}, 
         l: function(){return txt_weekdays[f.w()]}, 
         N: function(){return f.w() + 1}, 
         S: function(){return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th'}, 
         w: function(){return jsdate.getDay()}, 
         z: function(){return (jsdate - new Date(jsdate.getFullYear() + "/1/1")) / 864e5 >> 0}, 
         
         // Week 
         W: function(){ 
          var a = f.z(), b = 364 + f.L() - a; 
          var nd2, nd = (new Date(jsdate.getFullYear() + "/1/1").getDay() || 7) - 1; 
          if(b <= 2 && ((jsdate.getDay() || 7) - 1) <= 2 - b){ 
           return 1; 
          } else{ 
           if(a <= 2 && nd >= 4 && a >= (6 - nd)){ 
            nd2 = new Date(jsdate.getFullYear() - 1 + "/12/31"); 
            return date("W", Math.round(nd2.getTime()/1000)); 
           } else{ 
            return (1 + (nd <= 3 ? ((a + nd) / 7) : (a - (7 - nd)) / 7) >> 0); 
           } 
          } 
         }, 
         
         // Month 
         F: function(){return txt_months[f.n()]}, 
         m: function(){return pad(f.n(), 2)}, 
         M: function(){return f.F().substr(0,3)}, 
         n: function(){return jsdate.getMonth() + 1}, 
         t: function(){ 
          var n; 
          if( (n = jsdate.getMonth() + 1) == 2 ){ 
           return 28 + f.L(); 
          } else{ 
           if( n & 1 && n < 8 || !(n & 1) && n > 7 ){ 
            return 31; 
           } else{ 
            return 30; 
           } 
          } 
         }, 
         
         // Year 
         L: function(){var y = f.Y();return (!(y & 3) && (y % 1e2 || !(y % 4e2))) ? 1 : 0}, 
         //o not supported yet 
         Y: function(){return jsdate.getFullYear()}, 
         y: function(){return (jsdate.getFullYear() + "").slice(2)}, 
         
         // Time 
         a: function(){return jsdate.getHours() > 11 ? "pm" : "am"}, 
         A: function(){return f.a().toUpperCase()}, 
         B: function(){ 
          // peter paul koch: 
          var off = (jsdate.getTimezoneOffset() + 60)*60; 
          var theSeconds = (jsdate.getHours() * 3600) + (jsdate.getMinutes() * 60) + jsdate.getSeconds() + off; 
          var beat = Math.floor(theSeconds/86.4); 
          if (beat > 1000) beat -= 1000; 
          if (beat < 0) beat += 1000; 
          if ((String(beat)).length == 1) beat = "00"+beat; 
          if ((String(beat)).length == 2) beat = "0"+beat; 
          return beat; 
         }, 
         g: function(){return jsdate.getHours() % 12 || 12}, 
         G: function(){return jsdate.getHours()}, 
         h: function(){return pad(f.g(), 2)}, 
         H: function(){return pad(jsdate.getHours(), 2)}, 
         i: function(){return pad(jsdate.getMinutes(), 2)}, 
         s: function(){return pad(jsdate.getSeconds(), 2)}, 
         //u not supported yet 
         
         // Timezone 
         //e not supported yet 
         //I not supported yet 
         O: function(){ 
          var t = pad(Math.abs(jsdate.getTimezoneOffset()/60*100), 4); 
          if (jsdate.getTimezoneOffset() > 0) t = "-" + t; else t = "+" + t; 
          return t; 
         }, 
         P: function(){var O = f.O();return (O.substr(0, 3) + ":" + O.substr(3, 2))}, 
         //T not supported yet 
         //Z not supported yet 
         
         // Full Date/Time 
         c: function(){return f.Y() + "-" + f.m() + "-" + f.d() + "T" + f.h() + ":" + f.i() + ":" + f.s() + f.P()}, 
         //r not supported yet 
         U: function(){return Math.round(jsdate.getTime()/1000)} 
        }; 
         
        return format.replace(/[\/]?([a-zA-Z])/g, function(t, s){ 
         if( t!=s ){ 
          // escaped 
          var ret = s; 
         } else if( f[s] ){ 
          // a date function exists 
          var ret = f[s](); 
         } else{ 
          // nothing special 
          var ret = s; 
         } 
         return ret; 
        }); 
    },
    submitForm: function (formName, nextFunction,that) {
        that.$refs[formName].validate(valid => {
            if (valid) {
                nextFunction()
            } else {
                return false;
            }
        });
    },
    filepath: function(value){

        if(value&&value.indexOf('public://')>-1){
            return value.replace('public://',process.env.VUE_APP_HOST+'/files/')
        }
        return value;
    },
    timestampToTime:function(data){
        var date = new Date(data * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
        var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
        var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
        var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
        return Y+M+D+h+m+s;
    },
    testTime:function(time){
        let nd = 24*3600;
        let nh = 3600;
        let nm = 60;
        let day = Math.floor(time/nd)
        let houre = Math.floor(time%nd/nh)<10?'0'+Math.floor(time%nd/nh):Math.floor(time%nd/nh)
        let minute = Math.floor(time%nd%nh/nm)<10?'0'+Math.floor(time%nd%nh/nm):Math.floor(time%nd%nh/nm)
        let second = Math.floor(time%nd%nh%nm)<10?'0'+Math.floor(time%nd%nh%nm):Math.floor(time%nd%nh%nm)
        if(day){
            return day+'天'+houre+'时'+minute+'分'+second+'秒'
        }else{
            return houre+'时'+minute+'分'+second+'秒'
        }
    },
    beforeUploadImg:function(type,file){
        const imgs = ['png','jpg','jpeg','gif'];
        const videos = ['mp4'];
        const words = ['pdf','doc','docx'];
        const ppts = ['ppt','pptx'];
        
        const suffix = file.name.substring(file.name.lastIndexOf('.')+1)
        const isLt2G = file.size / 1024 / 1024 / 1024 <2
        const isLt950M = file.size / 1024 / 1024 < 950;
        const isLt20M = file.size / 1024 / 1024  < 20;
        const isLt100M = file.size / 1024 / 1024 < 100;
        const result = {success:true,msg:''};
        if(type === 'step') {
            if(imgs.indexOf(suffix)==-1){
                result.success = false
                result.msg = '只允许上传图片'
                return result
            }
        }
        if(imgs.indexOf(suffix)!==-1){
            if(!isLt20M) {
                result.success = false
                result.msg = '上传的图片大小不能超过20M!'
                return result
            }
        }else{
            if(!isLt950M) {
                result.success = false
                result.msg = '上传的文件大小不能超过950M!'
                return result
            }
        }
        return result;
    },
    transferUrl:function(data){
        var pop = document.createElement('div');
        pop.id = "user-pop"
        document.body.insertBefore(pop, document.body.lastChild);
        let host = 'http://'+window.location.host
        $.getScript(configStore.getter.baseUrl.UC_BASE_URL + "/uniapi/userPopup", function () {
            userTreePopup.share({
                token: getRcToken(),
                uid: getRcUid(),
                className:'user-pop',
                container:pop,
                width: 800,
                height: 600,
                onSubmit: function (res) {
                    pop.remove()
                    return true;
                },
                onClose:function(){
                    pop.remove()
                }
            }, {
                msg: data.title,
                share: {
                    text: data.text,
                    thumb_url: data.thumb_url,
                    message_link: host + data.message_link,
                    source_desc: "鹿客竞练",
                    source_image: host + "/js.ico",
                }
            })
        });
    },
}
